export default __webpack_public_path__ + "static/media/ksztalty-sport.a8fc5fd6.svg";